<app-data-table title="Action Logs"
                [columns]="columns"
                [fetchDataFn]="loadData"
                [exportDataFn]="exportData"
                defaultSortField="created_at"
                defaultSortOrder="desc"
                [exportable]="authService.hasPermission('logs.action_logs.export')">
</app-data-table>
